"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var addHandler = function (handler) {
    return window.addEventListener('beforeunload', handler);
};
var removeHandler = function (handler) {
    return window.removeEventListener('beforeunload', handler);
};
/**
 * Accepts a function called when the window is
 * unloaded (closed) and optionally when the
 * component unmounts.
 *
 * @param handler       Callback to be invoked.
 * @param callOnCleanup Invoke the callback when the component is dismounted.
 */
var useWindowUnloadEffect = function (handler, callOnCleanup) {
    if (callOnCleanup === void 0) { callOnCleanup = false; }
    var prevHandler = react_1.useRef(null);
    react_1.useEffect(function () {
        // Remove the the current event listener, if one exists
        if (prevHandler.current !== null) {
            removeHandler(prevHandler.current);
        }
        // ref.current is no longer write only: https://github.com/DefinitelyTyped/DefinitelyTyped/issues/31065
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        prevHandler.current = handler;
        addHandler(handler);
        return function () {
            if (callOnCleanup) {
                handler();
            }
            removeHandler(handler);
        };
    }, [callOnCleanup, handler]);
};
exports.default = useWindowUnloadEffect;
//# sourceMappingURL=useWindowUnloadEffect.js.map